export const ROW_STATE_NAME = "RowState";

export enum ModelState {
  Browse,
  Add,
  Edit,
  Delete,
  Added,
  Edited,
  Deleted,
  Canceled,
  Loaded,
  Loading,
  MaskAsDeleted,
  Error,
  SettingChange,
  StateChange
}

export enum DeletionMode {
  Hard, //hard delete
  // Mark,
  Soft //soft delete
}

export enum DataType {
  String = 0,
  Number = 1,
  Date = 2,
  Boolean = 3,
  Lookup = 4
}

export enum FilterOperator {
  None = 0,
  Contains = 1,
  GreaterThan = 2,
  GreaterThanOrEqual = 4,
  LessThan = 8,
  LessThanOrEqualTo = 16,
  StartsWith = 32,
  EndsWith = 64,
  Equals = 128,
  NotEqual = 256,
  Between = 1024,
  In = 2048
}

export enum DefaultWhenType {
  None = 0,
  Numeric = 1,
  Text = 2
}

export enum CrudAction {
  None = 0,
  Load = 1,
  Create = 2,
  Read = 4,
  Update = 8,
  Delete = 16
}

export enum TriggerAction {
  none,
  open,
  close
}

export enum NavigationMode {
  Default = 0,
  Routing = 1,
  Modal = 2
}

export enum DismissReason {
  Cancel,
  Ok
}

export enum ListAction {
  Add,
  Edit,
  Delete,
  Paginate,
  Refresh
}

export enum PushMode {
  Last,
  First,
  Current
}

export enum ValueType {
  undefined,
  constant,
  function,
  property
}

export enum SortDirection {
  Ascendent,
  Descendent
}

/*
EF EntityState enum
*/
export enum EntityState {
  Detached = 0,
  Unchanged = 1,
  Deleted = 2,
  Modified = 3,
  Added = 4
}

export enum SaveMode {
  IDENTITY,
  WITHOUT_IDENTITY
}
